import React, {
  FC,
  ButtonHTMLAttributes,
  ReactElement,
  useState,
  useEffect,
} from 'react';
import loader from '../../assets/svg/activity-loader.svg';
import clsx from 'clsx';

const classes = {
  base: 'flex items-center    transition-colors focus-visible:outline-none disabled:opacity-50 disabled:pointer-events-none ',
  disabled: 'opacity-50 cursor-not-allowed',
  size: {
    normal: 'h-10 py-2 px-4 leading-4 text-fontSize16 ',
    large: 'h-12 py-2 px-4 leading-4 text-fontSize16 ',
    small: 'h-6 py-1 px-2 text-xs',
    noheight: '',
  },
  rounded: {
    normal: 'rounded-borderRadius10  ',
    notSet: '',
  },
  border: {
    none: 'border-none ',
    notSet: '',
  },
  variant: {
    addButton: 'bg-blue-90 text-blue-00 ',
    addEntryButton: 'bg-blue-90 text-blue-0 ',
    primary: 'bg-blue-00 text-white text-center',
    danger: 'bg-red-00/10 text-red-00',
    secondary: 'bg-inputBackground text-neutral-12',
    stepButtonActive: 'bg-neutral-40 text-white/[0.87]',
    text: ' ',
  },
  position: {
    bettwen: 'justify-between',
    center: 'justify-center',
    start: 'justify-start',
  },
  font: {
    semiBold: 'font-semibold',
    normal: 'font-normal',
  },
};
interface IProps extends ButtonHTMLAttributes<HTMLButtonElement> {
  description?: any;
  buttonClass?: string;
  showLeftTick?: boolean;
  children?: any;
  isLoading?: boolean;
  variant?:
    | 'addButton'
    | 'primary'
    | 'danger'
    | 'secondary'
    | 'text'
    | 'addEntryButton'
    | 'stepButtonActive';
  border?: 'none' | 'notSet';
  size?: 'normal' | 'large' | 'small' | 'noheight';
  font?: 'semiBold' | 'normal';
  rounded?: 'normal' | 'notSet';
  position?: 'center' | 'bettwen' | 'start';
  icon?: ReactElement | null;
  iconRigth?: ReactElement | null;
  fullwidth?: boolean;
  fullSpin?: boolean;
  fullSpinComponent?: ReactElement | null;
  checkOnlineStatus?: boolean;
}

export const MainButton = ({
  description,
  showLeftTick,
  buttonClass,
  isLoading,
  className,
  variant = 'primary',
  font = 'semiBold',
  size = 'normal',
  position = 'center',
  rounded = 'normal',
  border = 'none',
  icon,
  iconRigth,
  fullSpin,
  fullSpinComponent,
  checkOnlineStatus = true,
  disabled,
  ...props
}: IProps): React.ReactElement => {
  const [isDisabled, setIsDisabled] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    if (disabled) setIsDisabled(true);
    else if (checkOnlineStatus) {
      setIsDisabled(!navigator.onLine);
    } else {
      setIsDisabled(false);
    }
  }, [disabled, checkOnlineStatus, navigator.onLine]);

  return (
    <button
      className={clsx(`
      ${className}
        ${classes.base}
        ${classes.size[size as keyof typeof classes.size]}
        ${classes.rounded[rounded as keyof typeof classes.rounded]}
        ${classes.variant[variant as keyof typeof classes.variant]}
        ${classes.position[position as keyof typeof classes.position]}
        ${classes.font[font as keyof typeof classes.font]}
        ${classes.border[border as keyof typeof classes.border]}

      `)}
      disabled={isDisabled}
      {...props}
    >
      {showLeftTick && (
        <span data-testid="icon-check" className="icon-check icon me-2 " />
      )}
      {isLoading && !fullSpin && (
        <span className="w-5 h-5 mr-4  justify-start    ">
          <img
            src={loader}
            alt="Loading"
            className="animate-spinner "
            data-testid="animate-spinner"
          />
        </span>
      )}
      {icon && !fullSpin && !isLoading ? icon : null}
      {!fullSpin ? (
        <span
          className={`max-w-full ${
            size !== 'small' ? 'h-full' : ''
          } flex items-center
        overflow-hidden whitespace-nowrap text-ellipsis ${
          icon ? 'max-w-[calc(100%-16px)]' : ''
        } rounded-xl `}
        >
          {description}
        </span>
      ) : null}
      {iconRigth && !fullSpin ? iconRigth : null}
      {fullSpin ? fullSpinComponent : null}
    </button>
  );
};
